import Api from '@/services/Api'
import axios from 'axios'

export default {
  // Método que llama a la url para crear un chat
  getActivitiesFile () {
     return Api().get("/activity-files");
  },
  updateActivityFile (params) {
    return Api().put("/activity-files",params);
  },
  addActivityFile (params) {
    return Api().post("/activity-files",params);
  },
  getActivityFile (params) {
    return Api().get("/activity-files/"+params);
  },
  getActivityFileByActivity (params) {
    return Api().get("/activity-files-by-activity/"+params);
  },
  deleteActivityFile (params) {
    return Api().delete("/activity-files/"+params);
  }
}



// WEBPACK FOOTER //
// ./src/services/ActivityFileService.js